import { render, staticRenderFns } from "./Main-Rules.vue?vue&type=template&id=2e058bf0&scoped=true&"
import script from "./Main-Rules.vue?vue&type=script&lang=js&"
export * from "./Main-Rules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e058bf0",
  null
  
)

export default component.exports